import { InjectionToken } from '../../injection';

/**
 * @deprecated Will be removed as soon as subpackages stop using it.
 */
export interface IDateFormatOptions {
  /**
   * If set to true, then current locale offset will not be applied to the provided UTC time. Useful for formatting date
   * strings that represent a particular day, week, month or year and not a particular date.
   *
   * E.G.: `2005-01-01T00:00:00Z` will always represent the 1st of January 2005, regardless of the applied timezone.
   */
  keepUtcTime: boolean;
}

/**
 * @deprecated Will be removed as soon as subpackages stop using it.
 */
export interface INumberFormatOptions {
  /**
   * For accounting purposes, negative numbers are presented as wrapped inside braces.
   *
   * By default all numbers are formatted as accounting numbers.
   */
  useMinusForNegatives?: boolean;
  currencyCode?: string;
}

/**
 * @deprecated Will be removed as soon as subpackages stop using it.
 */
export type MomentFunction = (inp?: Date | string | number, format?: string) => Date;

/**
 * @deprecated Will be removed as soon as subpackages stop using it.
 */
export interface IMobizFormatService {
  /**
   * Returns the current locale to be used by formatters.
   */
  readonly currentLocale: string;
  /**
   * Returns a date adapter function to be used for complex date formatting.
   */
  readonly moment: MomentFunction;

  formatDate(
    value: Date | string | number,
    format: string,
    options?: IDateFormatOptions,
  ): string;

  formatNumber(
    value: number,
    format: string,
    options?: INumberFormatOptions,
  ): string;
}

/**
 * @deprecated Will be removed as soon as subpackages stop using it.
 */
export const MOBIZ_FORMAT_SERVICE: InjectionToken<IMobizFormatService>
  = new InjectionToken<IMobizFormatService>('MOBIZ_FORMAT_SERVICE');
